import {Freeze} from 'react-freeze';
import React from 'react';

import MapPage, {MapPageProps} from '~organisms/MapPage';
import LandList, {LandListProps} from '~organisms/LandList';
import {ScreenTypes} from '~constants/routes';

type MapListProps = {
    mapPageProps: MapPageProps;
    landListProps: LandListProps;
    securedPage?: boolean;
    screen?: ScreenTypes;
};

const MapList = ({
    mapPageProps,
    landListProps,
    securedPage,
    screen,
}: MapListProps) => {
    return (
        <>
            <Freeze freeze={screen === ScreenTypes.List}>
                <MapPage {...mapPageProps} withWallet={securedPage} />
            </Freeze>
            <Freeze freeze={screen === ScreenTypes.Map}>
                <LandList
                    {...landListProps}
                    withWallet={securedPage}
                    data-cy={'list-container'}
                />
            </Freeze>
        </>
    );
};

export default MapList;
